/* eslint-disable no-unused-vars */
export enum NavigationState {
  SEARCH = 'search',
  MOBILE = 'mobile',
}
